
document.addEventListener("DOMContentLoaded", function () {
  const fixJudgeMe = () => {
    document.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]').forEach(el => {
      el.removeAttribute('role');
    });
  };

  fixJudgeMe();

  // In case Judge.me loads dynamically
  const observer = new MutationObserver(fixJudgeMe);
  observer.observe(document.body, { childList: true, subtree: true });
});
document.querySelectorAll('.shopify-dns-link-icon').forEach(el => {
  el.removeAttribute('role'); // remove invalid ARIA role
  el.setAttribute('alt', ''); // or meaningful text if needed
  el.setAttribute('aria-hidden', 'true'); // if decorative
});